export default __webpack_public_path__ + "static/media/40Dimic.1a9b40a0.jpg";